function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M49.4,56.5L35,42.2h-4v11.1h-3V42.2h-3.2L10.4,56.5l-2.1-2.1l12.3-12.3l-20.7,0v-3h2V6.5h-2v-3H60v3h-2v32.6h1.7v3 l-20.5,0l12.3,12.3L49.4,56.5z M4.8,39.1H55V6.5H4.8V39.1z"
})))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M33.8,30.4h-7.6v-1.5c0-1.8-1.8-3.8-2.4-4.4c-1.6-1.6-2.5-3.8-2.5-6c0-2.2,0.9-4.3,2.4-5.9c1.6-1.6,3.7-2.5,5.9-2.5 c2.2,0,4.3,0.9,5.9,2.4c1.6,1.6,2.4,3.7,2.4,5.9c0,2.2-0.9,4.4-2.4,5.9c0,0-1.8,1.9-1.8,4.4V30.4z M29.1,27.4H31 c0.5-2.9,2.5-4.9,2.6-5c1-1,1.6-2.4,1.6-3.8c0-1.4-0.6-2.8-1.6-3.8c-1-1-2.4-1.6-3.8-1.6c-1.4,0-2.8,0.6-3.8,1.6 c-1,1-1.6,2.4-1.6,3.8c0,1.4,0.6,2.8,1.6,3.8C26.2,22.6,28.4,24.7,29.1,27.4z"
}))))), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
  x: 25.8,
  y: 33,
  width: 8.5,
  height: 3
})))));

var SvgPresentationBoard = function SvgPresentationBoard(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/presentation-board.f9d8c421.svg";
export { SvgPresentationBoard as ReactComponent };